// Cart Footer Collapsible Handler
if (!window.CartFooterCollapsibleHandler) {
  window.CartFooterCollapsibleHandler = class CartFooterCollapsibleHandler {
    constructor() {
      this.init();
    }

    init() {
      // Initial setup
      this.setupCollapsibleListeners();

      // Watch for DOM changes to handle dynamically added elements
      this.observeDOMChanges();

      // Wait for everything to be properly rendered before calculating height
      this.waitForProperRendering();
    }

    waitForProperRendering() {
      // Wait for images and other resources to load
      if (document.readyState === "complete") {
        this.updateCartSeparatorHeightWithDelay();
      } else {
        window.addEventListener("load", () => {
          this.updateCartSeparatorHeightWithDelay();
        });
      }
    }

    updateCartSeparatorHeightWithDelay() {
      // Multiple attempts with increasing delays to ensure proper rendering
      setTimeout(() => {
        this.updateCartSeparatorHeight();
      }, 100);

      setTimeout(() => {
        this.updateCartSeparatorHeight();
      }, 300);

      setTimeout(() => {
        this.updateCartSeparatorHeight();
      }, 500);
    }

    setupCollapsibleListeners() {
      const cartFooter = document.getElementById("main-cart-footer");
      if (!cartFooter) return;

      const collapsibleButtons =
        cartFooter.querySelectorAll("collapsible-button");

      collapsibleButtons.forEach((button) => {
        // Remove existing listeners to avoid duplicates
        button.removeEventListener("click", this.handleCollapsibleClick);
        button.addEventListener(
          "click",
          this.handleCollapsibleClick.bind(this)
        );

        // Listen for transitionend events
        const collapsibleContent = button.parentElement.querySelector(
          ".collapsible-content"
        );
        if (collapsibleContent) {
          collapsibleContent.removeEventListener(
            "transitionend",
            this.handleTransitionEnd
          );
          collapsibleContent.addEventListener(
            "transitionend",
            this.handleTransitionEnd.bind(this)
          );
        }
      });

      // Ensure all collapsibles are closed on initial load
      this.ensureCollapsiblesClosed();
    }

    ensureCollapsiblesClosed() {
      const cartFooter = document.getElementById("main-cart-footer");
      if (!cartFooter) return;

      const collapsibleTabs = cartFooter.querySelectorAll(".collapsible-tab");
      collapsibleTabs.forEach((tab) => {
        // Remove 'open' class if present
        tab.classList.remove("open");

        // Ensure content height is 0
        const content = tab.querySelector(".collapsible-content");
        if (content) {
          content.style.height = "0px";
        }
      });
    }

    handleCollapsibleClick() {
      // Use setTimeout to allow the collapsible animation to complete
      setTimeout(() => {
        this.updateCartSeparatorHeight();
      }, 0); // Match the transition duration from CSS
    }

    handleTransitionEnd(event) {
      // Check if the transitionend event is for the height property
      if (event.propertyName === "height") {
        this.updateCartSeparatorHeight();
      }
    }

    updateCartSeparatorHeight() {
      const mainCartFooter = document.getElementById("main-cart-footer");
      const cartSeparator = document.querySelector(".cart-page-separator");

      if (mainCartFooter && cartSeparator) {
        const footerHeight = mainCartFooter.offsetHeight;

        // Only update if the height is reasonable (not too large)
        if (footerHeight > 0 && footerHeight < 2000) {
          cartSeparator.style.height = `${footerHeight}px`;
        } else {
          console.log(
            "Skipping height update - footer height seems incorrect:",
            footerHeight
          );
        }
      }
    }

    observeDOMChanges() {
      // Create a MutationObserver to watch for changes in the cart footer
      const cartFooter = document.getElementById("main-cart-footer");
      if (!cartFooter) return;

      const observer = new MutationObserver((mutations) => {
        let shouldUpdate = false;

        mutations.forEach((mutation) => {
          if (mutation.type === "childList") {
            // Check if collapsible elements were added or removed
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (
                  node.tagName === "COLLAPSIBLE-BUTTON" ||
                  (node.querySelector &&
                    node.querySelector("collapsible-button"))
                ) {
                  shouldUpdate = true;
                }
              }
            });

            mutation.removedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (
                  node.tagName === "COLLAPSIBLE-BUTTON" ||
                  (node.querySelector &&
                    node.querySelector("collapsible-button"))
                ) {
                  shouldUpdate = true;
                }
              }
            });
          }
        });

        if (shouldUpdate) {
          // Re-setup listeners after DOM changes
          setTimeout(() => {
            this.setupCollapsibleListeners();
            this.updateCartSeparatorHeight();
          }, 100);
        }
      });

      // Start observing
      observer.observe(cartFooter, {
        childList: true,
        subtree: true,
      });
    }
  };
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new window.CartFooterCollapsibleHandler();
  });
} else {
  new window.CartFooterCollapsibleHandler();
}

// Also initialize when cart is updated (for dynamic content)
document.addEventListener("cart:updated", () => {
  setTimeout(() => {
    new window.CartFooterCollapsibleHandler();
  }, 100);
});
